import { createAction } from "redux-actions";

import { moduleSlug } from "modules/InitialScrapeTaskBatchStarts/services/constants";
import {moduleSlug as namespace} from "modules/InitialScrapeTaskBatchStarts/services/constants";

export const clearInitialScrapeTaskBatchStarts = createAction(`${moduleSlug}/CLEAR_INITIAL_SCRAPE_TASK_BATCH_STARTS`);

export const getInitialScrapeTaskBatchStarts = createAction(`${moduleSlug}/GET_INITIAL_SCRAPE_TASK_BATCH_STARTS`);
export const getInitialScrapeTaskBatchStartsSuccess = createAction(`${moduleSlug}/GET_INITIAL_SCRAPE_TASK_BATCH_STARTS/SUCCESS`);
export const getInitialScrapeTaskBatchStartsError = createAction(`${moduleSlug}/GET_INITIAL_SCRAPE_TASK_BATCH_STARTS/ERROR`);

export const setInitialScrapeTaskBatchStartDialog = createAction(`${moduleSlug}/SET_INITIAL_SCRAPE_TASK_BATCH_START_DIALOG`);
export const mergeInitialScrapeTaskBatchStartDialog = createAction(`${moduleSlug}/MERGE_INITIAL_SCRAPE_TASK_BATCH_START`);
export const initialScrapeTaskBatchStart = createAction(`${moduleSlug}/INITIAL_SCRAPE_TASK_BATCH_START`);

export const exportResultObjects = createAction(`${moduleSlug}/EXPORT_RESULT_OBJECTS`);
export const setDownloadResultObjectsDialog = createAction(`${namespace}/SET_DOWNLOAD_RESULT_OBJECTS_DIALOG`);
export const mergeDownloadResultObjectsDialog = createAction(`${namespace}/MERGE_DOWNLOAD_RESULT_OBJECTS_DIALOG`);

export const getDetailedProgressInfo = createAction(`${moduleSlug}/GET_DETAILED_PROGRESS_INFO`);
export const setDetailedProgressInfo = createAction(`${moduleSlug}/SET_DETAILED_PROGRESS_INFO`);
